import { RxUpload } from 'react-icons/rx'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { Button } from '~/components/ui/atoms/button/Button'
import { ButtonSize, ButtonVariant } from '~/components/ui/atoms/button/types'

export type TableUploadActionsProps = {
  variant?: ButtonVariant
  size?: ButtonSize
  setOpenTableBulkUploadDialog: (open: boolean) => void
}

/**
 * Renders the button to open the Table Bulk Upload Dialog
 */
export function TableUploadActions({
  variant = 'tertiary',
  size = 'medium',
  setOpenTableBulkUploadDialog,
}: TableUploadActionsProps) {
  const { t } = useTypedTranslation()

  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        onClick={() => setOpenTableBulkUploadDialog(true)}
        size={size}
        startIcon={<RxUpload />}
        variant={variant}
      >
        {t('table.upload.title')}
      </Button>
    </div>
  )
}
